export const SHOPIFY_HOST = 'https://innovade-shisha.myshopify.com/api/2024-10';
export const WORDPRESS_HOST = 'https://innovade.uk/index.php';
export const STAMPED_HOST = 'https://stamped.io/api/v2/163877/dashboard/reviews';
export const STAMPED_USERNAME = 'pubkey-8604Yrc66y214G47juk1sr92mcWx7s';
export const STAMPED_PASSWORD = 'key-8Tz8LHMK7V1743Ug49TR7jd16QGI5h';